//**************************************************************
import { 
          Component,
          ViewChild,
          Inject,
          LOCALE_ID
        }                               from '@angular/core';

// Router
import { Router, ActivatedRoute }       from '@angular/router';

import { Observable, Subscription }     from 'rxjs';
//**************************************************************
// Firestore 
import { firestorecontrol }             from "../../appfirestore/app.firestore";
//**************************************************************
import {  
          DxFormComponent,
          DxSchedulerComponent,
          DxGanttComponent,
          DxToolbarComponent      
      }                                 from 'devextreme-angular';

import { custom }                       from 'devextreme/ui/dialog';

import { CustomRule }                   from "devextreme/common"
//**************************************************************
import Toolbar                          from "devextreme/ui/toolbar"

// Field Definitions
import  { 
          scheduler
        }                               from '../../appfirestore/app.fields';
//**************************************************************
// Functions
import { appfunctions  }                                    from '../../functions/app.functions';
import {  FormatWidth, 
          formatDate, 
          getLocaleDateFormat,
          getLocaleDateTimeFormat }     from '@angular/common';

import 'devextreme/integration/jquery';
//**************************************************************
@Component(
            {
              selector: 'app-comappointment',
              templateUrl: './comappointment.component.html',
              styleUrls: ['./comappointment.component.scss']
            }
          )


//**************************************************************
export class ComappointmentComponent 
  {
    //**************************************************************
    eventid: string = '';
    formheight: number = 0;

    subscriptionscheduler: Subscription;
    subscriptionschedulerlist: scheduler[];

    //*******************************************************
    @ViewChild('scheduler') scheduler: DxSchedulerComponent;
    //*******************************************************

    agendaageduration: number = 30;
    currentDate: string       = formatDate( new Date(), 'yyyy-MM-dd', 'en' );
    scheduleview: string      = "day"

    myDialog: any;

    dateformat: string;
    datetimeformat: string;

    startdatehhmm: string;
    enddatehhmm: string;
    //**************************************************************
    constructor (
                  private _Activatedroute:ActivatedRoute,
                  private firestoredata: firestorecontrol, 
                  private appfunction: appfunctions,
                  @Inject(LOCALE_ID) public locale: string
                ) 
          { 
            

          }
    //**************************************************************
    ngOnInit(): void 
      {
        //---------------------------------------------------------------------------------------------
        // EventId
        this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
        //---------------------------------------------------------------------------------------------
        // Establish Connection to Ganntt Parent -> Scheduler Items
        this.firestoredata.loadscheduler( this.eventid, 1, 1,  '', null, null );

        this.subscriptionscheduler = this.firestoredata.getscheduler().subscribe
          ( items => 
            { 
              this.subscriptionschedulerlist = items;
            }
          )
        //---------------------------------------------------------------------------------------------
        // Date Format
        const shortDateFormat       = getLocaleDateFormat('en-AU' , FormatWidth.Short);
        const shortDateTimeformat   = getLocaleDateTimeFormat( 'en-AU', FormatWidth.Short )    

        this.dateformat     = shortDateFormat; // d/M/yy
        this.datetimeformat =  this.dateformat + ', h:mm a'
     
        //---------------------------------------------------------------------------------------------
      }
    //**************************************************************
    ngOnDestroy() 
      {
        this.subscriptionscheduler.unsubscribe()
      }
    //**************************************************************
    onContentReadyAgenda( event: any)
      {
        let toolbarInstance = Toolbar.getInstance( event.component.element().find(".dx-toolbar") );
      
        let items = toolbarInstance.option("items");

        toolbarInstance.option("items", [
                                          items[0],
                                          {
                                            widget: "dxSelectBox",
                                            
                                            options: {
                                                        width: 50,
                                                        value:  this.agendaageduration,
                                                        dataSource: [
                                                                        7,
                                                                        14,
                                                                        30,
                                                                        60,
                                                                        120,
                                                                        240,
                                                                        360 
                                                                    ],

                                                        
                                                        onValueChanged: (args) =>   {
                                                                                      this.agendaageduration = args.value;
                                                                                    }
                                                      },
                                            location: "after"
                                          }
                                        ]
                                );


      }
    //**************************************************************
    customizeAgendaDateNavigatorText = (e) => 
      {

        let formatOptions = { 
                                year:   '2-digit', 
                                month:  'numeric', 
                                day:    'numeric' 
                            };

        //console.log( e )
        //  var formattedStartDate = e.startDate.toLocaleString("en", formatOptions);
        var formattedStartDate = formatDate(e.startDate,  this.dateformat , 'en');

        var formattedEndDate = formatDate(e.endDate,  this.dateformat , 'en');
      
        return formattedStartDate + "-" + formattedEndDate;
    
      }
    //**************************************************************
    onAppointmentTooltipShowing( event:any, seloption: number )
    {
      switch ( seloption )
        {
          case 1: 
            {
              event.cancel = true;
              break;
            }
        }

    }
    //**************************************************************
    onAgendaAppointmentClick( event: any )
    {

      var seldate: Date;
      var scrolldate: Date;
      var agendaseldate: Date;
      var SelYear: number;
      var SelMth: number;
      var SelDay: number;
      var SelHr: number;
      var SelMin: number;

      // Gets the Date Selected from the Agenda 
      // Set the Date for View Scheduler
      this.scheduleview = 'day';

      this.scheduler.instance._refresh;
     
      agendaseldate     = new Date ( event.appointmentData.startDate );
      seldate           = agendaseldate;

      SelYear = seldate.getFullYear();
      SelMth  = seldate.getMonth() + 1;
      SelDay  = seldate.getDate();
      SelHr   = seldate.getHours();
      SelMin  = seldate.getMinutes();
      //console.log( SelYear + '#' + SelMth + '#' + SelDay + '#' + SelHr + '#' + SelMin)

      let end     = formatDate( agendaseldate, 'yyyy-MM-dd', 'en' );
      scrolldate  = new Date( SelYear, SelMth-1, SelDay )

      this.currentDate  = end;
     
      this.scheduler.instance.scrollTo( new Date( SelYear, SelMth-1, SelDay, SelHr, SelMin) )           
    }
  //*******************************************************
  onAgendaAppointmentDblClick( event: any )
    {
      // Suppress opening 
      event.cancel = true;
    }
   //*******************************************************
   onAppointmentFormOpening(event: any ) 
    {
     
      //---------------------------------------------------------------------------------------------
      var newenddate: Date;
      const that = this;
      const form = event.form;

    //  console.log( form )
      //---------------------------------------------------------------------------------------------
      // PopUp Form
      event.popup.option( 
                          {
                            width: 500,
                            height: 430,
                            'showTitle': true,
                                  //     position: { my: 'right', 
                                  //                 at: 'top', 
                                  //                 of: "popscheduler", 
                                  //                 offset: { x: 18, y: 410 }   
                                      
                                      
                                  //               }
                               
                          }
                          
                        )

      event.popup.option('title', 'Edit Appointment');

      if (  event.appointmentData.title  == undefined )
        {
          event.appointmentData.endDate = event.appointmentData.startDate 

          newenddate                    = new Date(Date.parse(event.appointmentData.endDate)),
          newenddate                    = new Date(  newenddate.getFullYear(), newenddate.getMonth(),  newenddate.getDate(),23,59);
        //  event.appointmentData.endDate = formatDate( newenddate, 'yyyy-MM-ddTHH:mm:ss', 'en' );

          event.appointmentData.endDate = new Date( newenddate )

          event.appointmentData.allDay  = false;

          event.popup.option('title', 'Create a new appointment');
        }
      //---------------------------------------------------------------------------------------------
    //  console.log( event )
      this.startdatehhmm = event.appointmentData.startDate
      //console.log( this.startdatehhmm )
      this.enddatehhmm  = event.appointmentData.endDate
      //console.log( this.enddatehhmm )

      // Form Option
      form.option("width",  460);
      form.option("height", 350);
      form.option("colCount", 3);
      
      form.option('items',
                        [

                          {
                              itemType: "group",
                              caption: "Schedule",
                              colSpan: 3,
                              colCount: 3,
                              items: [

                                        {
                                          dataField: 'title',
                                          editorType: 'dxTextBox',
                                          colSpan: 3,
                                        
                                          label:  {
                                                    text: 'Subject',
                                                  },

                                          editorOptions: 
                                                  {
                                                    type: 'string',
                                                    width: 460
                                                  },

                                          validationRules: [
                                                              {
                                                                type: 'required',
                                                                message: 'Subject is required'
                                                              }
                                                           ]
                                        },
                                       
                                        {
                                          dataField: 'startDate',
                                          editorType: 'dxDateBox',

                                          label:  
                                            {
                                              text: 'Start Date/Time',
                                            },

                                          editorOptions: 
                                            {
                                              value: event.appointmentData.startDate,
                                              type: 'datetime',
                                              displayFormat: this.datetimeformat,
                                              onValueChanged(args) {
                                                                    
                                                                      this.startdatehhmm = args.value;
                                                                     // console.log( 'fdffff:' + this.startdatehhmm )
                                                                   },
                                              width: 150,
                                            },

                                          validationRules: 
                                            [
                                              {
                                                type: 'custom',
                                                reevaluate:'true',
                                                validationCallback: function( e: any )
                                              
                                                                            {
                                                                                this.startdatehhmm = e.value;
                                                                                //console.log( 'Start:' + this.startdatehhmm )
                                                                            
                                                                                this.enddatehhmm = form.option('formData.endDate');
                                                                                //console.log( 'End:' + this.enddatehhmm )

                                                                              if  ( this.startdatehhmm == null  || this.enddatehhmm == null )
                                                                                {
                                                                                  
                                                                                  return false;

                                                                                }

                                                                              else
                                                                                {

                                                                                    const startgetday = new Date( this.startdatehhmm ).getDate();
                                                                                    const endgetday = new Date( this.enddatehhmm ).getDate();
                                                                                  
                                                                                    if  ( ( startgetday == endgetday ) && ( new Date( this.startdatehhmm ) < new Date( this.enddatehhmm  ) ) )
                                                                                      {
                                                                                          return true
                                                                                        }
                                                                                    else
                                                                                      {
                                                                                        ;
                                                                                        return false
                                                                                      }
                                                                                 }

                                                                            },
                                                  message:  'Please recheck start & End Dates'
                                              }
                                            ]

                                          

                                        
                                        },

                                        {

                                          dataField: 'endDate',
                                          editorType: 'dxDateBox',
                                          label:  
                                            {
                                              text: 'End Date/Time',
                                            },

                                          editorOptions: 
                                            {
                                              value: event.appointmentData.endDate,
                                              type: 'datetime',
                                              displayFormat: this.datetimeformat,
                                              onValueChanged(args) {
                                                                      this.enddatehhmm = args.value;
                                                                    },
                                              width: 150,
                                            },

                                          validationRules: 
                                            [
                                              {
                                                type: 'custom',
                                                reevaluate:'true',
                                                validationCallback: function( e: any )
                                              
                                                                            {
                                                                               this.enddatehhmm = e.value;
                                                                               // console.log( 'endate:' + this.enddatehhmm )

                                                                               this.startdatehhmm = form.option('formData.startDate');

                                                                               // console.log( 'startdate:' +  this.startdatehhmm )

                                                                               if  ( this.startdatehhmm == null  || this.enddatehhmm == null )
                                                                                {
                                                                                  return false;
                                                                                }
                                                                              else
                                                                                {
                                                                                    const startgetday = new Date( this.startdatehhmm ).getDate();
                                                                                    const endgetday = new Date( this.enddatehhmm ).getDate();
                                                                                 
                                                                                    if ( ( startgetday == endgetday ) && ( new Date( this.enddatehhmm ) > new Date( this.startdatehhmm ) ) )
                                                                                      {
                                                                                          return true
                                                                                        }
                                                                                    else
                                                                                      {
                                                                                        return false
                                                                                      }

                                                                                }

                                                                            },
                                                  message:  'Please recheck start & End'
                                              }
                                            ]
                                        },

                                        {
                                          dataField: 'allDay',
                                          editorType: 'dxCheckBox',
                                          
                                          editorOptions: 
                                            {
                                              value: event.appointmentData.allDay,
                                              type: 'boolean',
                                              width: 150,
                                            }
                                        },

                                        {
                                          dataField: 'description',
                                          editorType: 'dxTextArea',
                                          colSpan: 3,
                                          label:  {
                                                    text: 'Notes',
                                                  },
                                          editorOptions: 
                                                  {
                                                    type: 'string',
                                                    width: 460,
                                                    height: 120
                                                  }
                                        },
                                     ]
                          }

                        ]
                    )

    }

    validdateinput(e): boolean
      {
        var textinput: string
          
        console.log( e )
        textinput = e.value;
        return ( textinput.length != 0 )

      }
    //**************************************************************
    onAppointmentAdding( event: any)
      {
        this.firestoredata.addNewSchedule( this.eventid, event.appointmentData, '0', '0');
      }
    //**************************************************************
    onAppointmentUpdated( event: any )
      {
        this.firestoredata.updateSchedule( this.eventid, event.appointmentData );
      }
    //**************************************************************
    onDeleteButtonClick(event: any, appointmentData: any): void 
    {
      //---------------------------------------------------------------------------------------------  
      this.myDialog = custom(
        {
            title: "Appointment",
            messageHtml: "<b>Remove Appointment</b>",
            buttons: [
                        {
                          text: "Yes",
                          onClick: (e) => {
                                            return { buttonText: e.component.option("text") }
                                          }
                        },
                        {
                          text: "No",
                          onClick: (e) => {
                                            return { buttonText: e.component.option("text") }
                                          }
                        }

                      ]
          }
      );
      //---------------------------------------------------------------------------------------------    
      this.myDialog.show().then((dialogResult) => {

                                                    if  ( dialogResult.buttonText == 'Yes')
                                                      {
                                                        // Create Firestore Deletion
                                                        this.firestoredata.deleteSchedule(  this.eventid, appointmentData.id)
                                                      }

                                                  }
                                );
      //---------------------------------------------------------------------------------------------
      event.event.stopPropagation();
      this.scheduler.instance.hideAppointmentTooltip();
    }
  //*******************************************************
  }
//**************************************************************
